<template>
  <div id="userMessage">
    <van-nav-bar :fixed="true" left-arrow @click-left="$router.back()">
      <template slot="title">
        <span class="title">客户录入</span>
      </template>
    </van-nav-bar>

    <van-form @submit="onSubmit" name="userinfo" ref="userinfo">
      <baseinfo
        v-if="step == 0"
        :useMessage="useMessage"
        @telerror="onTelerror"
      ></baseinfo>

      <div style="margin: 16px">
        <van-row>
          <van-col span="12">
            <van-button round block @click.prevent="$router.back()"
              >取消</van-button
            >
          </van-col>

          <van-col span="12">
            <van-button
              round
              block
              type="info"
              native-type="submit"
              :disabled="telerror"
              >提交</van-button
            >
          </van-col>
        </van-row>
      </div>
    </van-form>
  </div>
</template>
<script>
import baseinfo from "../register/baseinfo";

export default {
  name: "userMessage",
  props: {},
  components: { baseinfo },
  data() {
    return {
      setpList: ["基本信息", "补充问卷"],
      step: 0,
      questionnaire: [],
      questres: {},
      telerror: true,
      projectname: "",
      useMessage: {
        所属项目: "新基业当代阅ΜΟΜΛ",
        客户姓名: "",
        性别: "1",
        客户电话: "",
        客户地区: "",
        详细地址: "",
        完整地址: "",
      },
    };
  },
  created() {
    this.projectname = "新基业当代阅ΜΟΜΛ";
    if (this.projectname == "") {
      alert("请选择项目");
    }
    this.id = this.$route.params.id;
    if (this.id != "new") {
      // this.$nextTick(() => {
      this.$request.customerDetial({ _id: this.id }).then((res) => {
        if (res.code == 0) {
          this.useMessage = res.data;

          //this.getQuestionnaire();
        }
      });
      // });
    } else {
      //this.getQuestionnaire();
    }
  },

  methods: {
    onTelerror(val) {
      console.log(val)
      this.telerror = val;
    },
    onSave() {
      this.$refs["userinfo"].submit();
    },
    //提交信息
    onSubmit(values) {
      this.useMessage.推介来源 = "顾问约访";
      this.useMessage.跟办顾问 = this.$store.state.account;
      this.useMessage.跟办顾问姓名 = this.$store.state.name;
      this.useMessage.完整地址 = `${this.useMessage.客户地区}-${this.useMessage.详细地址}`;
      this.$request.customerSave(this.useMessage).then((res) => {
        if (res.code == 0) {
          this.$toast({
            message: "保存成功",
          });
          this.$router.back();
        } else {
          this.$toast({
            message: res.msg,
          });
        }
      });

      // this.restUseMessge();
    },

    // getQuestionnaire() {
    //   let req = {
    //     table_name: "sys_questionnaire",
    //     req: { 所属项目: this.projectname},
    //     sort: "order",
    //   };
    //   this.$request.dbreq(req).then((res) => {
    //     this.$set(this, "questionnaire", res.data.items);
    //     this.questionnaire = res.data.items;

    //     if (this.useMessage.appendinfo == undefined) {
    //       this.useMessage.appendinfo = [];
    //       for (var i in this.questionnaire) {
    //         let q = this.questionnaire[i];
    //         this.useMessage.appendinfo[i] = {
    //           title: q.title,
    //         };
    //       }
    //     }

    //     // appendinfo
    //   });
    // },
    // fullReqs() {
    //   for (var i in this.questionnaire) {
    //     let title = this.questionnaire[i].title;
    //     let flag = true;
    //     for (var j in this.useMessage.appendinfo) {
    //       if (this.useMessage.appendinfo[j].title == title) {
    //         flag = false;
    //       }
    //     }
    //     if (flag) this.useMessage.appendinfo.push({ title: title });
    //   }

    //   for (var i in this.useMessage.appendinfo) {
    //     let title = this.useMessage.appendinfo[i].title;
    //     this.useMessage.appendinfo[i].value = this.questres[title].value;
    //   }
    // },

    //清空表单
    restUseMessge() {
      this.useMessage = {
        客户姓名: "",
        性别: "1",
        客户电话: "",
        客户地区: "",
        详细地址: "",
        完整地址: "",
      };
    },
  },
};
</script>
<style scoped lang="less">
#userMessage {
  box-sizing: border-box;
  padding: 10px;
  padding-top: 48px;
  background: #fff;
}
.title {
  font-size: 12px;
}
.van-button {
  margin: 0 10px;
}
.subtitle {
  font-size: 10px;

  color: cadetblue;
}
</style>